import styled from 'styled-components';
import { cssColorValue, semanticColors, spacer16, spacer24, spacer32 } from '@spotify-internal/encore-web';

const StyledCard = styled.div<{ $noMarginTop?: boolean }>`
  ${props => !props?.$noMarginTop && `margin-top: ${spacer32};`}
  padding: ${spacer24} ${spacer16};
  border-radius: 8px;
  background: ${cssColorValue(semanticColors.backgroundElevatedHighlight)};
`;

export default StyledCard;
